/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {ManualFormerTenureInterestNotificationModalComponent} from './manual-former-tenure-interest-notification-modal.component';

export interface ManualFormerTenureInterestNotificationModalProps {
    formerTenures: any[];
    newFormerTenureInterestNotification?: any;
}

@Injectable({
    providedIn: 'root'
})
export class ManualFormerTenureInterestNotificationModalService extends ModalService {
    showModal(props: ManualFormerTenureInterestNotificationModalProps) {
        this.createModalComponent(ManualFormerTenureInterestNotificationModalComponent);
        const component = this.modalComponentRef.instance as ManualFormerTenureInterestNotificationModalComponent;
        component.formerTenures = props.formerTenures;
        component.existingNotification = props.newFormerTenureInterestNotification;
        this.showModalComponent();
        return component.modalClosed;
    }
}
